import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../url';

const DOC_TYPES = [
  { code: 'OTHER',    label: 'W-9 Form' },
  { code: 'OTHER',    label: 'Insurance Certificate' },
  { code: 'NDA',      label: 'Non-Disclosure Agreement (NDA)' },
  { code: 'CONTRACT', label: 'Contract / Agreement' },
  { code: 'MSA',      label: 'Master Services Agreement (MSA)' },
  { code: 'PO',       label: 'Purchase Order (PO)' },
  { code: 'SOW',      label: 'Statement of Work (SOW)' },
  { code: 'OTHER',    label: 'Business License' },
  { code: 'OTHER',    label: 'W-8BEN' },
  { code: 'OTHER',    label: 'Other Document' },
];

const SupplierDocumentUpload = ({ onUploaded }) => {
  const [file, setFile] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState('');
  const [title, setTitle] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleUpload = async () => {
    setError('');
    setSuccess('');

    if (!file) { setError('Please select a file.'); return; }
    if (selectedIndex === '') { setError('Please select a document type.'); return; }

    const selectedDoc = DOC_TYPES[parseInt(selectedIndex, 10)];
    const docTypeCode = selectedDoc.code;
    const docTitle = title.trim() || selectedDoc.label;

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('documentTypeCode', docTypeCode);
      formData.append('title', docTitle);

      const token = localStorage.getItem('supplierToken');
      const res = await axios.post(
        `${BASE_URL}/api/supplier-portal/upload-document`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
      );

      if (res.data.success) {
        setSuccess('✅ Document uploaded successfully!');
        setFile(null);
        setSelectedIndex('');
        setTitle('');
        const fileInput = document.getElementById('supplier-doc-file-input');
        if (fileInput) fileInput.value = '';
        onUploaded && onUploaded();
      } else {
        setError(res.data.message || 'Upload failed');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error uploading document');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', maxWidth: '520px' }}>
      <h4 style={{ margin: '0 0 20px', fontSize: '16px', color: '#111827', display: 'flex', alignItems: 'center', gap: '8px' }}>
        📁 Upload Your Documents
      </h4>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {/* Document Type */}
        <div>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
            Document Type <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <select
            value={selectedIndex}
            onChange={e => setSelectedIndex(e.target.value)}
            style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px', color: '#111827', background: '#fff' }}
          >
            <option value="">Select document type…</option>
            {DOC_TYPES.map((t, idx) => (
              <option key={idx} value={idx}>{t.label}</option>
            ))}
          </select>
        </div>

        {/* Title */}
        <div>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
            Title <span style={{ color: '#6b7280', fontWeight: 400 }}>(optional)</span>
          </label>
          <input
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder="e.g. Company Insurance 2026"
            style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px', boxSizing: 'border-box' }}
          />
        </div>

        {/* File picker */}
        <div>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
            File <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <input
            id="supplier-doc-file-input"
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={e => setFile(e.target.files[0])}
            style={{ width: '100%', fontSize: '14px' }}
          />
          {file && (
            <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#6b7280' }}>
              Selected: <strong>{file.name}</strong> ({(file.size / 1024).toFixed(1)} KB)
            </p>
          )}
        </div>
      </div>

      {error   && <div style={{ marginTop: '16px', background: '#fef2f2', color: '#ef4444', padding: '10px', borderRadius: '6px', fontSize: '14px' }}>{error}</div>}
      {success && <div style={{ marginTop: '16px', background: '#ecfdf5', color: '#065f46', padding: '10px', borderRadius: '6px', fontSize: '14px' }}>{success}</div>}

      <button
        onClick={handleUpload}
        disabled={uploading}
        style={{
          marginTop: '20px', width: '100%', padding: '10px',
          background: uploading ? '#d1d5db' : '#3b5bfd',
          color: '#fff', border: 'none', borderRadius: '8px',
          fontWeight: '600', fontSize: '14px', cursor: uploading ? 'not-allowed' : 'pointer'
        }}
      >
        {uploading ? 'Uploading…' : '⬆ Upload Document'}
      </button>
    </div>
  );
};

export default SupplierDocumentUpload;
